/*
 * A simple workaround for browsers without IntersectionObserver. This works
 * only when observer is instantly disconnected after one or more observe()
 * calls. This runs once and does not continue observing changes.
 */
if (!window.IntersectionObserver) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.IntersectionObserver = function (cb) {
    const elements: HTMLElement[] = [];
    let timer;

    return {
      disconnect: () => {
        /* noop */
      },
      observe: element => {
        clearTimeout(timer);
        elements.push(element);
        timer = setTimeout(() => {
          cb(
            elements.map(el => ({
              boundingClientRect: el.getBoundingClientRect()
            }))
          );
        });
      }
    };
  };
}
